/* ═══════════════════════════════════════════════════════════════════════════
   GRAVV DESIGN TOKENS
   Single source of truth — import { T } from "./design/tokens"
═══════════════════════════════════════════════════════════════════════════ */
export const T = {
  // ── Backgrounds ────────────────────────────────────────────────────────
  bg:           "#F6F1E8",   // Parchment — fond principal
  surface:      "#FFFFFF",   // White — cards, panels
  card:         "#FFFFFF",
  surfaceSub:   "#EDE8DD",   // Surface secondaire légèrement plus sombre
  border:       "#EAE4D8",   // Sand Border — séparateurs, bordures cards
  borderStrong: "#D8D0C0",

  // ── Brand ──────────────────────────────────────────────────────────────
  navy:         "#1A1510",   // Void Warm — fond sombre, textes primaires, wordmark
  navyMid:      "#3A3530",   // Void mid — bordures sombres
  gold:         "#C49A3C",   // Warm Gold — CTA, symbole, KPIs critiques
  goldLight:    "#FAF3E4",   // Gold teinté clair
  goldDark:     "#9A7828",   // Gold foncé — hover, ombres CTA
  lime:         "#C49A3C",   // alias gold (compatibilité)
  limeDeep:     "#9A7828",   // alias goldDark (compatibilité)
  accent:       "#C49A3C",

  // ── Sémantique ─────────────────────────────────────────────────────────
  green:        "#5A9E38",   // Trail Green — validation, positif, D+
  greenLight:   "#EEF6E8",
  orange:       "#C85C2A",   // Ochre Alert — effort, zones critiques, alertes
  orangeLight:  "#FCEEE6",
  red:          "#C85C2A",   // même ochre
  redLight:     "#FCEEE6",
  blue:         "#2563EB",   // bleu système (graphiques, zones)
  blueLight:    "#EFF6FF",
  purple:       "#7C3AED",
  purpleLight:  "#F5F3FF",

  // ── Textes ─────────────────────────────────────────────────────────────
  text:         "#1A1510",   // Void Warm — texte primaire
  textMid:      "#9A8F7E",   // Flint — labels, descriptions, metadata
  textLight:    "#B0A090",   // Pebble — placeholders, sec-labels, hints

  // ── Ombres ─────────────────────────────────────────────────────────────
  shadow:    "0 1px 0 rgba(26,21,16,0.06), 0 2px 8px rgba(26,21,16,0.07), 0 0 0 0.5px rgba(26,21,16,0.07)",
  shadowMd:  "0 2px 0 rgba(26,21,16,0.07), 0 6px 20px rgba(26,21,16,0.10), 0 0 0 0.5px rgba(26,21,16,0.07)",
  shadowLg:  "0 4px 0 rgba(26,21,16,0.08), 0 16px 48px rgba(26,21,16,0.14)",
  shadowInset: "inset 0 1px 3px rgba(26,21,16,0.08)",

  // ── Typographie ────────────────────────────────────────────────────────
  fontUI:   "'Bricolage Grotesque', sans-serif",   // Interface, navigation, textes
  fontData: "'Barlow Condensed', sans-serif",       // Données chiffrées, KPIs, temps
};
